import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const StyledObjetive = styled.div.attrs({ id: 'menu-objetive' })`
  background-color: ${props => props.theme.colors.activeBlue};
  display: flex;
  font-size: ${props => props.theme.fontSize.small};
  margin-top: ${rem('4px')};

  ${mediaqueries.between('tablet', 'desktop')`
    font-size: inherit;
  `};
`;

export const StyledObjetiveWeekly = StyledObjetive.extend`
  margin-top: ${rem('10px')};

  ${mediaqueries.greaterThan('desktop')`
    flex-direction: column;
    margin-left:${rem('10px')};
    margin-top: 0;
    min-height:${rem('339px')};
    padding: 8% ${rem('35px')} 5%;
    width:${rem('493px')};
  `};
`;

export const StyledObjetiveIcons = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: ${rem('24px')};
  width: ${rem('160px')};
`;

export const StyledObjetiveIconsWeekly = StyledObjetiveIcons.extend`
  margin-top: ${rem('10px')};

  ${mediaqueries.greaterThan('desktop')`
    flex-direction: initial;
    justify-content: initial;
    margin-right: 0;
    width: 100%;
  `};
`;

export const StyledObjetiveList = styled.div`
  margin: 0;
  ${mediaqueries.greaterThan('tablet')`
    padding: ${rem('16px')} 0
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('12px')} 0
  `};
`;

export const StyledObjetiveListWeekly = StyledObjetiveList.extend`
  ${mediaqueries.greaterThan('desktop')`
    margin: ${rem('10px')} 0 ${rem('24px')};
  `};
`;

export const ItemObjetiveList = styled.dl`
  display: flex;
  margin: 0;
`;

export const StyledObjetiveType = styled.dt`
  font-family: ${props => props.theme.fonts.medium};
  margin: 0;

  ${mediaqueries.greaterThan('tablet')`
    min-width: ${rem('138px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.small};
    min-width: ${rem('120px')};
  `};
`;

export const StyledObjetiveTypeWeekly = StyledObjetiveType.extend`
  ${mediaqueries.greaterThan('desktop')`
    font-size: 1rem;
    margin-bottom: ${rem('6px')};
  `};
`;

export const StyledObjetiveFood = styled.dd`
  display: inline-block;
  margin: 0;

  ${mediaqueries.lessThan('mobile')`
    font-family: ${props => props.theme.fonts.medium};
  `};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.small};    
  `};
`;

export const StyledObjetiveFoodWeekly = StyledObjetiveFood.extend`
  ${mediaqueries.greaterThan('desktop')`
    font-size: 1rem;
    margin-bottom: ${rem('6px')};
  `};
`;
